import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";

const CONSENT_KEY = "inv_consent_v2";

const setConsent = (granted) => {
  const payload = granted
    ? {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        security_storage: "granted",
      }
    : {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "granted",
        security_storage: "granted",
      };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(payload));
  } catch (e) {
    /* noop */
  }
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", payload);
  }
};

const CookieBanner = () => {
  const { t, lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const existing = localStorage.getItem(CONSENT_KEY);
      if (!existing) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    setConsent(true);
    setVisible(false);
  };
  const handleReject = () => {
    setConsent(false);
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label={t("cookieBanner.title")}
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4"
    >
      <div className="max-w-5xl mx-auto bg-[#0F172A] border border-slate-700 rounded-lg shadow-xl p-5 sm:p-6">
        <div className="flex flex-col md:flex-row md:items-start gap-4">
          <div className="flex-1">
            <p className="text-sm font-semibold text-slate-100 mb-1">
              {t("cookieBanner.title")}
            </p>
            <p className="text-sm text-slate-400 leading-relaxed">
              {t("cookieBanner.text")}{" "}
              <Link
                to={`/${lang}/cookies`}
                data-testid="cookie-banner-policy-link"
                className="text-emerald-400 hover:text-emerald-300 underline underline-offset-2"
              >
                {t("cookieBanner.preferences")}
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              data-testid="cookie-banner-reject-button"
              onClick={handleReject}
              className="px-4 py-2 text-sm rounded-md border border-slate-600 text-slate-200 hover:bg-slate-800"
            >
              {t("cookieBanner.reject")}
            </button>
            <button
              type="button"
              data-testid="cookie-banner-accept-button"
              onClick={handleAccept}
              className="px-4 py-2 text-sm rounded-md bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
            >
              {t("cookieBanner.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
